<template>
  <div
    class="modal show w-100 d-flex"
    role="dialog"
    aria-labelledby="staticBackdropLiveLabel"
    style="background-color:rgba(0,0,0,0.3)"
  >
    <div
      class="modal-dialog modal-dialog-centered border-0"
      role="document"
    >
      <div class="modal-content border-0">
        <div
          class="modal-body p-md-4 border-0 d-flex flex-column"
        >
          <div class="d-flex row">
            <div class="col-2">
              <div class="d-flex ms-auto">
                <v-icon
                  icon="chevron-left"
                  class="cursor-pointer"
                  @click="closeModal"
                />
              </div>
            </div>
            <div class="col-7 text-center">
              <div class="d-none d-md-inline-block h5 text-center mb-3">
                Filtres
              </div>
            </div>
            <div
              class="col-3 text-end fw-bold cursor-pointer"
              @click="resetFilter"
            >
              Effacer
            </div>
          </div>
          <div class="row mb-auto">
            <div class="col-12">
              <div
                v-for="(filter, filterIndex) in filters"
                :key="`${filter.title}-${filterIndex}`"
              >
                <div
                  class="fw-bold my-2 text-blue-700"
                >
                  {{ filter.title }}
                </div>
                <v-badges
                  :badges="filter.badges"
                  class="mb-3"
                  @update-active="(index) => updateActiveBadge(filterIndex, index)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary w-100"
                @click="applyFilter"
              >
                Appliquer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Badges from './FiltersBadges.vue';

export default {
  components: { 'v-badges': Badges },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['apply-filter', 'update:filter', 'close-filter', 'reset-filter'],
  computed: {
    ...mapGetters({
      isToolBarOpen: 'ui/isToolBarOpen',
    }),
  },
  methods: {
    applyFilter() {
      this.$emit('apply-filter');
    },
    updateActiveBadge(filterIndex, index) {
      this.$emit('update:filter', { filterIndex, index });
    },
    closeModal() {
      this.$emit('close-filter');
    },
    resetFilter() {
      this.$emit('reset-filter');
    },
  },
};
</script>
<style scoped>
button.list-group-item {
  height: 60px;
  width: 300px;
  max-width: 300px;
  text-align: center;
}
.transition-icon-up {
  transition: all 0.7s;
  transform: rotate(0deg);
}
.transition-icon-down {
  transition: all 0.7s;
  transform: rotate(180deg);
}
.modal-content {
  min-width: 500px;
  min-height: 400px;
}
@media screen and (max-width: 576px) {
  .modal-dialog,
  .modal-content {
    max-height: calc(100vh - 16px);
    min-height: calc(100vh - 16px);
    max-width: calc(100vw - 16px);
    min-width: unset;
  }
  .modal {
    padding: 0;
    margin: 0,
  }
}
</style>
